export var GlobalActions;
(function (GlobalActions) {
    GlobalActions["reset"] = "RESET";
    GlobalActions["showNotification"] = "SHOW_NOTIFICATION";
    GlobalActions["hideNotification"] = "HIDE_NOTIFICATION";
    GlobalActions["openModalBasic"] = "OPEN_MODAL_BASIC";
    GlobalActions["hideModalBasic"] = "HIDE_MODAL_BASIC";
    GlobalActions["setCountry"] = "SET_COUNTRY";
    GlobalActions["setUserProfile"] = "SET_USER_PROFILE";
    GlobalActions["setCommercialProcessesById"] = "SET_COMMERCIAL_PROCESSES_BY_ID";
    GlobalActions["setCommercialProcessSelected"] = "SET_COMMERCIAL_PROCESS_SELECTED";
})(GlobalActions || (GlobalActions = {}));
